import { BaseResource } from 'src/modules/models/base-resource';
export class Venue extends BaseResource {
    constructor() {
        super();
        this.type = "Venue";
    }
    name: string;
    isAllSeasonalPerBooking: boolean = true;
}
